<template>
  <div class="online-payment-policy">
    <div class="text-secondary online-payment-policy-title">
      {{ $t('payment.online-payment-policy') }}
    </div>
    <div class="online-payment-policy-cards">
      <div class="online-payment-policy-card">
        <collapsed-setting-card
          :title="$t('payment.activation')"
          :collapsed="expanded !== 'activation'"
          @update:collapsed="handleCollapse($event, 'activation')"
        >
          <div class="online-payment-policy-terms">
            {{ $t('payment.activation-description') }}
          </div>
        </collapsed-setting-card>
      </div>

      <div class="online-payment-policy-card">
        <collapsed-setting-card
          :title="$t('payment.terms-of-user')"
          :collapsed="expanded !== 'terms'"
          @update:collapsed="handleCollapse($event, 'terms')"
        >
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="scrollable-container online-payment-policy-terms scroll-area"
            tagname="div"
          >
            <div
              dir="ltr"
              v-html="onlinePaymentTerms"
            />
          </vue-perfect-scrollbar>
        </collapsed-setting-card>
      </div>

      <div class="online-payment-policy-card">
        <collapsed-setting-card
          :title="$t('payment.payment-methods-fees')"
          :collapsed="expanded !== 'fees'"
          @update:collapsed="handleCollapse($event, 'fees')"
        >
          <fees-list />
        </collapsed-setting-card>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CollapsedSettingCard from '@/@okmenu/components/cards/CollapsedSettingCard'
import onlinePaymentTerms from '@/constants/online-payment/online-payment-terms'
import FeesList from '@/views/admin/purchase/components/FeesList'

export default {
  name: 'OnlinePaymentPolicy',
  components: {
    FeesList, CollapsedSettingCard, VuePerfectScrollbar,
  },
  data() {
    return {
      expanded: null,
      onlinePaymentTerms,
      perfectScrollbarSettings: {
        wheelPropagation: false,
      },
    }
  },
  methods: {
    handleCollapse(collapsed, type) {
      if (collapsed) {
        this.expanded = null
      } else {
        this.expanded = (this.expanded !== type ? type : null)
      }
    },
  },
}
</script>

<style lang="scss">
.online-payment-policy {
  .online-payment-policy-title {
    margin: 0 16px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.75;
  }

  .online-payment-policy-terms {
    max-height: 382px;
    line-height: 1.56;
    font-size: 17px;
    font-weight: 500;
  }

  .online-payment-policy-cards {
    .collapsed-setting-card {
      margin-top: 10px;
      box-shadow: none;

      .collapsed-setting-header {
        padding: 16px 0 !important;
        font-size: 18px;
        line-height: 1.56;
        color: var(--black);
        font-weight: 600;

        .btn-icon {
          padding: 5px 14px;
        }

        .collapsed-setting-title {
          font-weight: 700;
        }
      }

      .collapsed-setting-body {
        margin: 0 30px;
      }
    }
  }
}
</style>
